import * as types from '../actions/actionTypes';
import initialState from './initialState';


        
export default function pagosReducer(state= initialState.pagos, action){
    let newState;
	switch(action.type){
         case types.LOAD_PAGOS_LIST_SUCCESS:		
            action.pagos.filtroActivo=state.filtroActivo;
            action.pagos.filtroActual=state.filtroActual;
            action.pagos.showActivos=state.showActivos;
			 action.pagos.paginaActual=action.pagos.pageable.pageNumber;
			 action.pagos.registrosPorPagina=action.pagos.size;
            
            return action.pagos;

        case types.BORRAR_PAGOS_SUCCESS:		            
            newState=Object.assign({}, state);
            newState.content=[...state.content.filter(pagos => pagos.id !== action.pagos.id)];          
			return newState;    
            
        case types.ACTIVAR_PAGOS_SUCCESS:		            
            newState=Object.assign({}, state);
            newState.content=[...state.content.filter(pagos => pagos.id !== action.pagos.id)];          
			 return newState;
            
        case types.SET_FILTRO_PAGOS:
			newState=Object.assign({}, state);
			newState.filtroActivo=action.filtro.filtroActivo;
			newState.filtroActual=action.filtro.filtroActual;
           newState.showActivos=action.filtro.showActivos;
            
            
			return newState;
		break;
            
		default:
			return state;
	}
}